<template>
  <div>
    <collapse
      title="Servicios solicitados y su clasificación como costos indirectos"
    >
      <label class="data-label">
        Los servicios solicitar son considerados como parte de los costos
        indirectos reclamados o a reclamar por el DEPR
      </label>
      <validation-provider v-slot="{ validated }" rules="required">
        <custom-radio
          v-model="hasIndirectCosts"
          class="custom-radio"
          custom-error-msg="El campo es requerido."
          :disabled="isReadOnly"
          is-inline
          name="indirectCost"
          :options="options"
        />
        <error
          v-if="validated && ![true, false].includes(hasIndirectCosts?.value)"
          message="El campo es requerido."
          variant="no-border"
        />
        <label class="data-label">
          (solo aplica a proyectos sufragados con fondos administrativos)
        </label>
      </validation-provider>
    </collapse>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomRadio from 'custom-radio';
import Error from 'custom-error';

export default {
  name: 'ServiceRequested',
  components: {
    Collapse,
    ValidationProvider,
    CustomRadio,
    Error,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasIndirectCosts: {
      get() {
        const value = this.options.find(
          (x) => x.value === this.model.hasIndirectCosts
        );

        return value ?? {};
      },
      set(option) {
        this.model.hasIndirectCosts = option?.value;
      },
    },
    options() {
      return [
        {
          id: 1,
          name: 'yes',
          label: 'Si',
          value: true,
        },
        {
          id: 2,
          name: 'no',
          label: 'No',
          value: false,
        },
      ];
    },
  },
};
</script>
<style scoped>
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-font {
  color: #727272;
  font-size: 14px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}
</style>
